import { createReducer, on } from '@ngrx/store';

import { customParameterActions } from '@app/core/store/custom-parameter/custom-parameter.actions';
import { CUSTOM_PARAMETER_INITIAL_STATE } from '@app/core/store/custom-parameter/custom-parameter.constant';

export const customParameterReducer = createReducer(
  CUSTOM_PARAMETER_INITIAL_STATE,
  on(customParameterActions.loadCustomParameters, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(customParameterActions.loadCustomParametersSuccess, (state, { parameters }) => ({
    ...state,
    parameters,
    loading: false,
    error: null
  })),
  on(customParameterActions.loadCustomParametersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
);
